export { TabbedPanel } from "./TabbedPanel";
export { TabbedPanelContentAreas } from "./TabbedPanelContentAreas";
export type {
  TabbedPanelProps,
  TabbedPanelItems,
  TabbedPanelItem,
} from "./TabbedPanel";
export type { TabbedPanelContentAreasProps } from "./TabbedPanelContentAreas";
